import React from 'react';
import { withStyles } from '@mui/styles';

const styles = {
    modalText: {
        lineHeight: '28px',
        '& p': {
            marginBottom: 0
        },
        '& li': {
            listStyle: 'unset',
            marginLeft: 25
        }
    }
};

const ModalText = ({ classes }) => (
    <div className={classes.modalText}>
        <p>By extending the deadline, selected candidates will be notified and granted additional time to complete the Skills Assessment.<br />
			This action will:
            <ul>
                <li><strong>Reset all question timers,</strong> giving candidates the original time allowance.</li>
                <li><strong>Preserve previously submitted answers.</strong></li>
                <li><strong>Remove any manual grades</strong> that were applied before the extension.</li>
            </ul>
			Are you sure you want to proceed?
        </p>
    </div>
);

export default withStyles(styles)(ModalText);
